/**
 * ラジオボタンの中身（オプションなし）
 *
 * @returns コンポーネント
 */
export default function KaraokeOrderFormView1WithoutOptionView() {
  return (
    <div className="radio__wrap">
      <h3 className="radio__header"><span className="radio__title">不要</span></h3>
      <p className="radio__price">
        0
        <span className="radio__price_small">円</span>
      </p>
    </div>
  );
}
